
const timestampInSeconds = timestampInMilliseconds => Math.floor(timestampInMilliseconds / 1000);

export const isTokenValid = authData => authData.expiresAtTimestamp > timestampInSeconds(Date.now());

export function hasValidToken() {
  const authData = getAuthData();

  if(!authData) {
    return false;
  }

  return isTokenValid(authData);
}

export function getAuthData() {
  const data = localStorage.getItem('authData');

  if(!data) {
    return null;
  }

  try {
    return JSON.parse(data);
  }
  catch(error) {
    return null;
  }
}

export function setAuthData(data) {
  localStorage.setItem('authData', JSON.stringify(data));
}

export function removeAuthData() {
  localStorage.removeItem('authData');
}



/** WEBPACK FOOTER **
 ** ./src/__shared__/authStore.js
 **/